// RFC 6266: `filename*` (RFC 5987, percent-encoded UTF-8) takes precedence over plain `filename`.
const ENCODED_FILENAME_PATTERN = /filename\*\s*=\s*([\w-]+)'[^']*'([^;]+)/i;
const PLAIN_FILENAME_PATTERN = /filename\s*=\s*(?:"((?:\\.|[^"\\])*)"|([^;]+))/i;

export function getContentDispositionFilename(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const encoded = ENCODED_FILENAME_PATTERN.exec(header);

  if (encoded) {
    try {
      return decodeURIComponent(encoded[2].trim());
    } catch {
      // Malformed percent-encoding — fall back to the plain `filename` parameter.
    }
  }

  const plain = PLAIN_FILENAME_PATTERN.exec(header);

  if (!plain) {
    return null;
  }

  const filename = plain[1] !== undefined ? plain[1].replace(/\\(.)/g, '$1') : plain[2].trim();

  return filename || null;
}
